module.exports = __webpack_public_path__ + "img/sales-icon.683ae7ec.png";